import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiClock, FiCalendar } from 'react-icons/fi';
import api from '../../utils/api';
import * as S from '../../styles/inlineStyles';

const UpcomingExams = () => {
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('all');
    const navigate = useNavigate();

    useEffect(() => { fetchExams(); }, []);

    const fetchExams = async () => {
        try {
            const res = await api.get('/api/student/upcoming-exams');
            console.log('[DEBUG] Frontend received exams:', res.data.exams);
            setExams(res.data.exams || []);
        } catch (err) {
            console.error('Failed to fetch exams');
        } finally {
            setLoading(false);
        }
    };

    const getTimeRemaining = (startTime) => {
        const diff = new Date(startTime) - new Date();
        if (diff <= 0) return 'Started';
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
    };

    const filteredExams = activeTab === 'all' ? exams : exams.filter(e => (e.examType || 'internal') === activeTab);

    if (loading) return <div style={S.loadingContainer}><div style={S.spinner} /><p style={S.loadingText}>Loading exams...</p></div>;

    return (
        <div className="page-enter main-content">
            <div style={S.pageHeader}>
                <h1 style={S.pageTitle}>📅 Upcoming Exams</h1>
                <p style={S.pageSubtitle}>Your scheduled examinations.</p>
            </div>

            {/* Exam Type Tabs */}
            <div style={S.tabsContainer}>
                {[
                    { key: 'all', label: '📋 All Exams' },
                    { key: 'internal', label: '📝 Internal' },
                    { key: 'semester', label: '🎓 Semester' },
                ].map(tab => (
                    <button key={tab.key} style={S.tabBtn(activeTab === tab.key)} className="tab-hover" onClick={() => setActiveTab(tab.key)}>
                        {tab.label}
                    </button>
                ))}
            </div>

            {filteredExams.length === 0 ? (
                <div style={S.card}><div style={S.emptyState}><span style={S.emptyIcon}>📅</span><h3 style={S.emptyTitle}>No Upcoming Exams</h3><p style={S.emptyText}>{activeTab === 'all' ? 'No examinations are currently scheduled.' : `No ${activeTab} exams scheduled.`}</p></div></div>
            ) : (
                <div style={S.grid3} className="responsive-grid">
                    {filteredExams.map(exam => (
                        <div key={exam.id} style={S.card} className="card-hover">
                            <div style={S.cardBody}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
                                    <h3 style={{ fontFamily: S.font, fontSize: 16, fontWeight: 700, margin: 0, color: S.colors.textPrimary }}>{exam.subject_name} ({exam.subject_code})</h3>
                                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                        <span style={S.badge(exam.examType || 'internal')} className="badge-hover">
                                            📝 Examination
                                        </span>
                                        <span style={S.badge(exam.state)} className="badge-hover">{exam.state}</span>
                                    </div>
                                </div>
                                <div style={{ fontSize: 13, color: S.colors.primary, fontWeight: 600, marginBottom: 12 }}>📖 {exam.department}</div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: S.colors.textSecondary }}><FiCalendar /> {exam.startTime ? new Date(exam.startTime).toLocaleString() : `${exam.exam_date} ${exam.exam_time}`}</div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: S.colors.textSecondary }}><FiClock /> {exam.duration} minutes</div>
                                        <div style={{ fontSize: 11, fontWeight: 700, background: '#f0fdf4', color: S.colors.primary, padding: '2px 8px', borderRadius: 6, border: '1px solid #c8e6d8' }}>
                                            {exam.total_marks} Marks
                                        </div>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                                    <span style={{ fontSize: 12, color: S.colors.textLight }}>Starts: <strong style={{ color: S.colors.primary }}>{exam.startTime ? getTimeRemaining(exam.startTime) : 'Pending'}</strong></span>
                                    {exam.state === 'LIVE' && <button className="btn-hover" style={{ ...S.btnPrimary, ...S.btnSmall }} onClick={() => navigate(`/student/exam/${exam.id}`)}>Enter Exam</button>}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default UpcomingExams;
